import React, { useState } from "react";
import { useMutation } from "@apollo/client";
//import bcrypt from "bcryptjs";
import { CREATE_LINK, FIND_LINKS_BY_SECTION } from "../queries";

import { useParams } from "react-router-dom";
import {
  TextField,
  Button,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import {useTranslation} from "react-i18next"
/*
import {useTranslation} from "react-i18next"
const [t, i18n] = useTranslation("common")
{t("headers.agendas")}

*/
import ReCAPTCHA from "react-google-recaptcha";
/* eslint-disable react/prop-types */
const LinkForm = ({ setError }) => {
  // eslint-disable-next-line;
  //const [t, i18n] = useTranslation("common");
  let section = useParams().id;
  const [t] = useTranslation("common");
  const [linktext, setText] = useState("");
  const [linkdatetime, setDatetime] = useState("");
  //const [initiativeid, setInitiative] = useState("");
  const [linktype, setType] = useState("");
  //const [userid, setUser] = useState("");
  //const [proposalid, setProposalid] = useState("");
  //const [commentid, setCommentid] = useState("");
  const [linkref, setLinkref] = useState("");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  //console.log(token);
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //console.log(setExecuting);
  const [createLink] = useMutation(CREATE_LINK, {
    refetchQueries: [{ query: FIND_LINKS_BY_SECTION, variables: { section } }],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const uusi = async (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    setDatetime(pvm.toString());
    setText(event);
  };
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }
  const submit = async (event) => {
    event.preventDefault();
    createLink({
      variables: {
        linktext,
        linkdatetime,
        sectionid: section,
        linktype,
        linkref,
      },
    });
    setText("");
    setDatetime("");
    setSubmitted(true);
  };
  if (submitted) {
    return (
      <div>
        <h2>{t("headers.addlink")}</h2>
        {t("common.formok")}
        <br />
      </div>
    );
  } else {
    return (
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h2>{t("headers.addlink")}</h2>
              <form onSubmit={submit}>
                {t("common.linktext")}
                <br />
                <TextField value={linktext} onChange={({ target }) => uusi(target.value)} />
                <br />
                <br />
                {t("common.linkref")}:
                <br />
                <TextField value={linkref} onChange={({ target }) => setLinkref(target.value)} />
                <br />
                <FormControl component="fieldset">
                  <FormLabel component="legend">{t("common.linktype")}</FormLabel>
                  <RadioGroup
                    aria-label="linktype"
                    name="linktype"
                    value={linktype}
                    onChange={({ target }) => setType(target.value)}
                  >
                    <FormControlLabel value="Sivu" control={<Radio />} label={t("common.site")} />
                    <FormControlLabel
                      value="Kuva"
                      control={<Radio />}
                      label={t("common.picture")}
                    />
                    <FormControlLabel value="Video" control={<Radio />} label={t("common.video")} />
                    <FormControlLabel value="Audio" control={<Radio />} label={t("common.audio")} />
                    <FormControlLabel
                      value="Dokumentti"
                      control={<Radio />}
                      label={t("common.document")}
                    />
                    <FormControlLabel value="Muu" control={<Radio />} label={t("common.other")} />
                    <FormControlLabel
                      value="99"
                      disabled
                      control={<Radio />}
                      label={t("common.notdefined")}
                    />
                  </RadioGroup>
                </FormControl>
                <br />
                <div>
                  <ReCAPTCHA
                    sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                    onChange={onChange}
                  />
                </div>
                <br />
                <br />
                <Button
                  style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                  type="submit"
                  disabled={!verified}
                  executing={executing}
                  submitted={submitted}
                >
                  {submitted ? t("common.done") : executing ? "Verifying" : t("common.send")}
                </Button>
                <br />
                <br />
              </form>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    );
  }
};

export default LinkForm;
